<template>
  <div id="video-main" :class="'a16by9 video-main-' + $store.getters.platform + ' video-main-'+ $store.getters.getData.template1">

    <div class="box-video">
      <video ref="video" class="video-js vjs-default-skin vjs-no-icons" loop :muted="$store.getters.muted && $store.getters.platform === 'browser'"></video>

      <div id="overlay">
        <div v-if="content" id="overlay-text">
          <span>{{content.name}}</span>
          <span v-if="content.description "><pre>{{content.description | truncateText(200)}}</pre></span>
          <span>
            <a v-on:click="onClick" v-on:keyup.enter="onClick" v-on:focus="onFocus" class="waves-effect waves-light btn-large focusable play" tabindex="-1">Play</a>
          </span>
        </div>

        <div id="mute-unmute" v-if="$store.getters.platform === 'browser' && $route.name === 'content'">
          <div v-if="$store.getters.muted" @click="setMuted(false)"><icon name="volume-mute" class="icon-shadow"></icon></div>
          <div v-else @click="setMuted(true)"><icon name="volume-up" class="icon-shadow"></icon></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SpatialNavigation from 'js-spatial-navigation'
import videojs from 'video.js'
require('videojs-contrib-hls')

export default {
  name: 'VideoMain',
  data () {
    return {
      player: null,
      content: null
    }
  },
  mounted () {
    this.player = videojs(this.$refs.video, {
      controls: false,
      autoplay: true,
      preload: 'auto',
      fluid: true,
      errorDisplay: false
    }, () => {
      this.setSrc()
    })

    window.addEventListener('scroll', this.onScroll, false)
  },
  methods: {
    setSrc: function () {
      if (this.$store.getters.getData.videotype === 'FIL' && this.$store.getters.getData.video) {
        this.player.src({type: 'video/mp4', src: this.$store.getters.getData.video})
      } else if (this.$store.getters.getData.videotype === 'CON' && this.$store.getters.getData.content && this.$store.getters.getData.content.trailer) {
        this.content = this.$store.getters.getData.content

        if (this.content.trailer.split('?')[0].slice(-3) === 'mp4') {
          this.player.src({type: 'video/mp4', src: this.$store.getters.getData.content.trailer})
        } else {
          this.player.src({type: 'application/x-mpegURL', src: this.$store.getters.getData.content.trailer})
        }
        this.SN = SpatialNavigation.add({ selector: '#overlay .focusable', restrict: 'self-first' })
        SpatialNavigation.makeFocusable(this.SN)
      }
    },
    playVideo () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop
      if (this.$route.name === 'content' && scrollTop < 300) { this.player.play() }
    },
    pauseVideo () { this.player.pause() },
    onScroll () {
      if (this.$route.name === 'content') {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop
        if (scrollTop > 300) {
          setTimeout(() => this.player.pause(), 0)
        } else {
          setTimeout(() => this.player.play(), 0)
        }
      }
    },
    onClick: function () {
      if (this.$store.getters.platform === 'browser' && !this.content.is_premium) {
        this.$router.push({name: 'content-view', params: { id: this.content.id }})
      } else {
        this.$router.push({name: 'content-detail', params: { id: this.content.id }})
      }
    },
    onFocus: function () { document.querySelector('#app-content').scrollTo(0, 0) },
    setMuted: function (valor) { this.$store.commit('setMuted', valor) }
  },
  beforeDestroy: function () {
    if (this.player) this.player.dispose()
    if (this.SN) SpatialNavigation.remove(this.SN)

    window.removeEventListener('scroll', this.onScroll, false)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

#video-main

  .box-video
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%

    video
      width: 100%
      height: 100%

#overlay
  position: absolute
  top: 0
  right: 0
  left: 0
  bottom: 0
  width: 100%
  height: 102%
  // background: linear-gradient(to top, rgba(0, 0, 0, .9), rgba(0, 0, 0, 0))
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), black 80%)

  .btn-large
    background-color: rgba(248, 249, 250, 0.3)

  .btn-large:focus, .btn-large:hover
    text-shadow: none

  #overlay-text
    margin-top: 4rem
    margin-left: 4rem
    color: #fff

    span
      float: left
      width: 60%
      line-height: 1.2
      text-shadow: #000000 0.1em 0.1em 0.2em
      color: inherit
      clear: left

    span:nth-child(1)
      font-size: 2.5rem
      font-weight: bold

    span:nth-child(2) pre
      white-space: pre-wrap
      font-family: 'Roboto Light', sans-serif;
      font-size: 1.2rem
      margin-top: .8rem

.center-icon
  font-size: 3rem
  display: inline-flex;
  vertical-align: middle;

#mute-unmute
  position: absolute
  right: 0
  top: 3rem
  color: white
  cursor: pointer
  margin: 5rem 2rem 0rem 0rem

  .icon-shadow
    font-size: 4rem
    filter: drop-shadow(0 0 0.1rem black)

</style>



// WEBPACK FOOTER //
// src/components/video-main.vue